import React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const GOLD = "#b98a52";
const DARK = "#12100e";
const CREAM = "#f7f1e7";
const WHATSAPP_NUMBER = "+525543776260";
const WHATSAPP_LABEL = "55 5377 6260";
const LOCAL_PHONE = "5555442699";
const LOCAL_PHONE_LABEL = "55 5544 2699";
const EMAIL = "isaacmartfun@gmail.com";
const ADDRESS =
  "Avenida 3 No. 45, Colonia Educación, Coyoacán, CDMX, C.P. 04400";
const MAPS_QUERY =
  "Av. 3 45, Petrolera Taxquena, Coyoacan, 04410 Ciudad de Mexico, CDMX, Mexico";

const contactOptions = [
  {
    title: "WhatsApp",
    value: WHATSAPP_LABEL,
    description: "La forma más rápida de consultar o recibir ayuda con tu reserva.",
    icon: <WhatsAppIcon />,
    href: `https://wa.me/${WHATSAPP_NUMBER}`,
    buttonLabel: "Escribir por WhatsApp",
    accent: "#16865c",
    background: "#eaf8f1",
    external: true,
  },
  {
    title: "Teléfono",
    value: LOCAL_PHONE_LABEL,
    description: "Comunicate directamente con el estudio para una atención personal.",
    icon: <PhoneRoundedIcon />,
    href: `tel:${LOCAL_PHONE}`,
    buttonLabel: "Llamar ahora",
    accent: "#3467c9",
    background: "#edf3ff",
  },
  {
    title: "Correo electrónico",
    value: EMAIL,
    description: "Escribinos para consultas generales o información adicional.",
    icon: <EmailRoundedIcon />,
    href: `mailto:${EMAIL}`,
    buttonLabel: "Enviar correo",
    accent: "#a45e42",
    background: "#fbeee9",
  },
  {
    title: "Visitanos",
    value: ADDRESS,
    description: "Estamos en Coyoacán, Ciudad de México. Abrí el mapa para llegar.",
    icon: <LocationOnRoundedIcon />,
    href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAPS_QUERY)}`,
    buttonLabel: "Cómo llegar",
    accent: "#b04a45",
    background: "#fceeed",
    external: true,
  },
];

const Contact = () => {
  return (
    <Box sx={{ bgcolor: "#fff", color: DARK }}>
      <Navbar />

      <Box
        component="section"
        sx={{
          position: "relative",
          overflow: "hidden",
          pt: { xs: 14, sm: 16, md: 18 },
          pb: { xs: 8, md: 11 },
          bgcolor: DARK,
          color: "#fff",
          backgroundImage:
            "radial-gradient(circle at 82% 24%, rgba(185,138,82,.3), transparent 28%), radial-gradient(circle at 8% 96%, rgba(185,138,82,.12), transparent 26%)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            opacity: 0.25,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.035) 1px, transparent 1px)",
            backgroundSize: "52px 52px",
          }}
        />
        <Container maxWidth="lg" sx={{ position: "relative" }}>
          <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center">
            <Grid item xs={12} md={7}>
              <Chip
                icon={<AutoAwesomeIcon sx={{ color: "#e2bd8d !important" }} />}
                label="ESTAMOS PARA AYUDARTE"
                sx={{
                  mb: 3,
                  color: "#f2d7b6",
                  bgcolor: "rgba(185,138,82,.14)",
                  border: "1px solid rgba(226,189,141,.28)",
                  fontWeight: 800,
                  letterSpacing: 1.1,
                }}
              />
              <Typography
                component="h1"
                sx={{
                  maxWidth: 720,
                  fontSize: { xs: "2.7rem", sm: "3.7rem", md: "4.5rem" },
                  lineHeight: 1.03,
                  letterSpacing: "-.045em",
                  fontWeight: 800,
                }}
              >
                Hablemos de tu próxima visita.
              </Typography>
              <Typography
                sx={{
                  maxWidth: 650,
                  mt: 3,
                  color: "rgba(255,255,255,.7)",
                  fontSize: { xs: 17, md: 20 },
                  lineHeight: 1.7,
                }}
              >
                Elegí el medio que te resulte más cómodo. Podemos ayudarte con
                consultas, reservas, servicios o indicaciones para llegar al estudio.
              </Typography>
            </Grid>

            <Grid item xs={12} md={5}>
              <Card
                elevation={0}
                sx={{
                  ml: { md: "auto" },
                  maxWidth: 410,
                  borderRadius: 5,
                  bgcolor: "rgba(255,255,255,.97)",
                  boxShadow: "0 30px 70px rgba(0,0,0,.28)",
                }}
              >
                <CardContent sx={{ p: { xs: 3, md: 4 }, "&:last-child": { pb: { xs: 3, md: 4 } } }}>
                  <Avatar sx={{ width: 54, height: 54, bgcolor: "#e8f7ef", color: "#16865c", mb: 2.5 }}>
                    <WhatsAppIcon />
                  </Avatar>
                  <Typography sx={{ color: GOLD, fontWeight: 900, fontSize: 11, letterSpacing: 1.3 }}>
                    CONTACTO RÁPIDO
                  </Typography>
                  <Typography variant="h5" fontWeight={800} sx={{ color: DARK, mt: 0.8 }}>
                    Escribinos por WhatsApp
                  </Typography>
                  <Typography sx={{ color: "#74695e", lineHeight: 1.7, mt: 1.2 }}>
                    Te ayudamos de forma directa desde el número oficial del estudio.
                  </Typography>
                  <Button
                    component="a"
                    href={`https://wa.me/${WHATSAPP_NUMBER}`}
                    target="_blank"
                    rel="noreferrer"
                    fullWidth
                    variant="contained"
                    endIcon={<ArrowForwardRoundedIcon />}
                    sx={{
                      mt: 3,
                      py: 1.35,
                      borderRadius: 99,
                      bgcolor: "#16865c",
                      fontWeight: 800,
                      textTransform: "none",
                      boxShadow: "none",
                      "&:hover": { bgcolor: "#10714c", boxShadow: "none" },
                    }}
                  >
                    Iniciar conversación
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box component="section" sx={{ py: { xs: 8, md: 12 }, bgcolor: "#faf8f4" }}>
        <Container maxWidth="lg">
          <Box maxWidth={700} mb={{ xs: 4, md: 6 }}>
            <Typography sx={{ color: GOLD, fontWeight: 900, letterSpacing: 1.4, fontSize: 12 }}>
              CANALES DE ATENCIÓN
            </Typography>
            <Typography
              variant="h2"
              sx={{ mt: 1.3, fontSize: { xs: "2.2rem", md: "3rem" }, lineHeight: 1.15, letterSpacing: "-.035em", fontWeight: 800 }}
            >
              Elegí cómo querés comunicarte.
            </Typography>
            <Typography sx={{ mt: 1.5, color: "#71675e", fontSize: 16, lineHeight: 1.7 }}>
              Todos nuestros medios de contacto en un solo lugar, claros y accesibles desde cualquier dispositivo.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {contactOptions.map((option) => (
              <Grid item xs={12} sm={6} key={option.title}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    borderRadius: 4,
                    border: "1px solid #e9e1d5",
                    bgcolor: "#fff",
                    transition: "transform .25s ease, box-shadow .25s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 20px 45px rgba(48,33,20,.09)",
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      p: { xs: 3, md: 3.5 },
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      "&:last-child": { pb: { xs: 3, md: 3.5 } },
                    }}
                  >
                    <Stack direction="row" spacing={2.2} alignItems="flex-start">
                      <Avatar sx={{ width: 52, height: 52, bgcolor: option.background, color: option.accent }}>
                        {option.icon}
                      </Avatar>
                      <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography variant="h6" fontWeight={800}>
                          {option.title}
                        </Typography>
                        <Typography
                          sx={{
                            color: DARK,
                            fontSize: option.title === "Visitanos" ? 15 : 18,
                            fontWeight: 700,
                            mt: 0.7,
                            overflowWrap: "anywhere",
                            lineHeight: 1.45,
                          }}
                        >
                          {option.value}
                        </Typography>
                      </Box>
                    </Stack>
                    <Typography sx={{ color: "#74695e", lineHeight: 1.7, mt: 2.4, mb: 2.7 }}>
                      {option.description}
                    </Typography>
                    <Button
                      component="a"
                      href={option.href}
                      target={option.external ? "_blank" : undefined}
                      rel={option.external ? "noreferrer" : undefined}
                      endIcon={<ArrowForwardRoundedIcon />}
                      sx={{
                        mt: "auto",
                        alignSelf: "flex-start",
                        color: option.accent,
                        px: 0,
                        fontWeight: 800,
                        textTransform: "none",
                        "&:hover": { bgcolor: "transparent", opacity: 0.75 },
                      }}
                    >
                      {option.buttonLabel}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box component="section" sx={{ py: { xs: 8, md: 12 }, bgcolor: "#fff" }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 4, md: 7 }} alignItems="stretch">
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  height: "100%",
                  minHeight: { md: 420 },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  borderRadius: 5,
                  p: { xs: 3.5, md: 5 },
                  bgcolor: CREAM,
                }}
              >
                <Avatar sx={{ width: 52, height: 52, bgcolor: "#fff", color: GOLD, mb: 3 }}>
                  <LocationOnRoundedIcon />
                </Avatar>
                <Typography sx={{ color: GOLD, fontSize: 12, fontWeight: 900, letterSpacing: 1.3 }}>
                  NUESTRA UBICACIÓN
                </Typography>
                <Typography variant="h4" sx={{ mt: 1.2, fontWeight: 800, letterSpacing: "-.025em" }}>
                  Te esperamos en Coyoacán.
                </Typography>
                <Typography sx={{ mt: 2, color: "#71675e", lineHeight: 1.75 }}>
                  {ADDRESS}
                </Typography>
                <Button
                  component="a"
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAPS_QUERY)}`}
                  target="_blank"
                  rel="noreferrer"
                  variant="contained"
                  endIcon={<ArrowForwardRoundedIcon />}
                  sx={{
                    mt: 3.5,
                    alignSelf: "flex-start",
                    bgcolor: DARK,
                    borderRadius: 99,
                    px: 2.7,
                    py: 1.2,
                    fontWeight: 800,
                    textTransform: "none",
                    "&:hover": { bgcolor: "#2a2521" },
                  }}
                >
                  Abrir en Google Maps
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} md={8}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  minHeight: { xs: 360, md: 500 },
                  overflow: "hidden",
                  borderRadius: 5,
                  border: "1px solid #e9e1d5",
                  boxShadow: "0 24px 60px rgba(45,31,18,.1)",
                }}
              >
                <Box
                  component="iframe"
                  title="Ubicación de Estudio Isaac"
                  src={`https://www.google.com/maps?q=${encodeURIComponent(MAPS_QUERY)}&output=embed`}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  sx={{ display: "block", width: "100%", height: "100%", minHeight: { xs: 360, md: 500 }, border: 0 }}
                />
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};

export default Contact;
